import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { NgClass } from '@angular/common';

type SKELETON_SCREENS = 'DEFAULT' | 'INPUT_PANEL' | 'BUTTON' | 'TEXT_BLOCK';

@Component({
  selector: 'webmodule-order-skeleton-screen',
  templateUrl: './skeleton-screen.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, TablerIconsModule],
  standalone: true,
})
export class SkeletonScreenComponent {
  @Input() type: SKELETON_SCREENS = 'DEFAULT';
  @Input() pulse = false;
}
